import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Hero = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const slides = [
        {
            title: "En Print Studio",
            subtitle: "Creemos que cada marca tiene una historia que contar.",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            cta: <Link key='servicios' to={`servicios`}>¡Conoce nuestro trabajo!</Link>
        },
        {
            title: "En Print Studio",
            subtitle: "Hacemos que tus ideas cobren vida con calidad, color y estilo.",
            background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
            cta: <Link key='logotool' to={`logotool`}>¿Cómo se vería tu logo?</Link>
        }
    ];

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 7000);
        return () => clearInterval(timer);
    }, [slides.length]);

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    };

    return (
        <section id="inicio" className="relative h-screen overflow-hidden">
            <AnimatePresence mode="wait">
                <motion.div
                    key={currentSlide}
                    className="absolute inset-0"
                    style={{ background: slides[currentSlide].background }}
                // initial={{ opacity: 0 }}
                // animate={{ opacity: 1 }}
                // exit={{ opacity: 0 }}
                // transition={{ duration: 1 }}
                >
                    {/* Animated background elements */}
                    <div className="absolute inset-0">
                        {[...Array(20)].map((_, i) => (
                            <motion.div
                                key={i}
                                className="absolute rounded-full bg-white/10"
                                style={{
                                    width: Math.random() * 100 + 50,
                                    height: Math.random() * 100 + 50,
                                    left: `${Math.random() * 100}%`,
                                    top: `${Math.random() * 100}%`,
                                }}
                                animate={{
                                    y: [0, -30, 0],
                                    opacity: [0.3, 0.7, 0.3],
                                }}
                                transition={{
                                    duration: Math.random() * 3 + 2,
                                    repeat: Infinity,
                                    delay: Math.random() * 2,
                                }}
                            />
                        ))}
                    </div>

                    {/* Content */}
                    <div className="relative z-10 h-full flex items-center justify-center text-center text-white">
                        <motion.div
                            initial={{ y: 50, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.8, delay: 0.2 }}
                            className="max-w-4xl mx-auto px-4"
                        >
                            <motion.h1
                                className="text-6xl md:text-8xl font-bold mb-6 gradient-text drop-shadow-md"
                                animate={{ scale: [1, 1.05, 1] }}
                                transition={{ duration: 4, repeat: Infinity }}
                            >
                                {slides[currentSlide].title}
                            </motion.h1>
                            <motion.p
                                className="text-xl md:text-2xl mb-8 text-white"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ duration: 0.8, delay: 0.5 }}
                            >
                                {slides[currentSlide].subtitle}
                            </motion.p>
                            <motion.button
                                className="bg-white text-black px-8 py-4 rounded-full font-semibold text-lg hover:bg-gray-100 smooth-transition hover-glow"
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                            >
                                {slides[currentSlide].cta}
                            </motion.button>
                        </motion.div>
                    </div>
                </motion.div>
            </AnimatePresence>

            {/* Navigation arrows */}
            <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white p-2 rounded-full glass-effect z-20 hover-glow  hover:bg-primary hover:scale-110"
            >
                <ChevronLeft size={32} />
            </button>
            <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white p-2 rounded-full glass-effect z-20 hover-glow hover:bg-primary hover:scale-110"
            >
                <ChevronRight size={32} />
            </button>

            {/* Slide indicators */}
            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
                {slides.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => setCurrentSlide(index)}
                        className={`w-3 h-3 rounded-full smooth-transition ${index === currentSlide ? 'bg-white' : 'bg-white/50'
                            }`}
                    />
                ))}
            </div>
        </section>
    );
};

export default Hero;